import React, { useState, useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../constants/RouteConstant";
import Pattern from "../assets/Pattern.png";
import Man from "../assets/Man4.png";
import ManMobile from "../assets/man5.png";

import { useSiteState } from "../hookState/SiteState";
import APIURLConstants from "../config/config";
import ApiHelper from "../utillity/ApiHelper";
import Helper from "../utillity/helper";
import { usePlanState } from "../hookState/PlanState";
import { setSocialLoginState } from "../hookState/SocialLoginState";
import { setCartState } from "../hookState/CartState";
import { premiumCount } from "../constants/Constant";
import ProductCard from "./Product/ProductCard";
import MobileProductCard from "./Product/MobileProductCard";

export const Hero = () => {
	const navigate = useNavigate();
	const state = useSiteState();
	const [products, setProducts] = useState([]);

	const [loading, setLoading] = useState(false);
	const [redirectPayment, setRedirectPayment] = React.useState(false);
	const [categoryId] = useState("all");

	const planState = usePlanState();
	const [cartCount, setCartCount] = useState(0);
	const [token, setToken] = useState("");
	const [perPage] = useState(1);
	const [currentPage] = useState(1);
	let [cart, setCart] = useState([]);
	const [snackBarProps, setSnackBarProps] = React.useState({
		openSnack: false,
		variant: "error",
		message: "",
	});
	const [cartAdded, setCartAdded] = useState([]);

	const loginOptionName = Helper.getStorage("loginOption");
	if (loginOptionName) {
		setSocialLoginState(loginOptionName);
	}

	const handlePayment = (price) => {
		navigate(RouteConstants.PAYMENT_GATEWAY, {
			state: { amount: price, type: "unlimited", cart: [] },
		});
		return;
	};
	const getProducts = () => {
		if (state.user.get()) {
			getData(state.user.id.get());
		} else {
			const cart = Helper.getStorage("cart");
			let cartAsin = [];
			if (cart) {
				let cartCopy = [...cart];
				cartAsin = cartCopy.map((key) => key.asin);
			}
			setLoading(true);
			const data = {
				per_page: perPage,
				current_page: currentPage,
				category_id: categoryId,
				user_id: 0,
				cartAsin: cartAsin,
			};
			ApiHelper.post(APIURLConstants.get_products, data)
				.then((res) => {
					setLoading(false);
					setProducts(res.data.result.products);
				})
				.catch((error) => {
					setLoading(false);
				});
		}
	};
	const getData = (id) => {
		setLoading(true);
		const data = {
			per_page: perPage,
			current_page: currentPage,
			category_id: categoryId,
			user_id: id,
		};
		ApiHelper.post(APIURLConstants.get_products, data)
			.then((res) => {
				setLoading(false);

				setProducts(res.data.result.products);
			})
			.catch((error) => {
				setLoading(false);
			});
	};
	const addCartItem = (productInfo) => {
		const dataLayerCart = Helper.getStorage("dataLayerCart");
		console.log(dataLayerCart);

		if (
			state.plan.get() !== null &&
			state.plan !== "" &&
			state.plan !== undefined
		) {
			if (cartCount >= premiumCount) {
				setSnackBarProps({
					openSnack: true,
					variant: "error",
					message: "Please contact to contact@ecominsider.net",
				});
				return;
			}

			// Helper.setStorage("dataLayerCart", productInfo);

			ApiHelper.post(APIURLConstants.add_products_myaccount, productInfo)
				.then((res) => {
					console.log(res);
					if (res.data) {
						if (res.data.success) {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Added in MyAccount",
							});

							if (dataLayerCart === null) {
								let dataLayerCartCopy = [];
								Helper.setStorage("dataLayerCart", productInfo);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: productInfo,
									},
								});
							} else {
								console.log("dataLayerCart", dataLayerCart);
								let dataLayerCartCopy = [dataLayerCart];

								dataLayerCartCopy.push(productInfo);
								Helper.setStorage("dataLayerCart", dataLayerCartCopy);

								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: dataLayerCartCopy,
									},
								});
							}
							getProducts();
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			ApiHelper.post(APIURLConstants.ADD_TO_CART, productInfo)
				.then((res) => {
					console.log(res);
					if (res.data) {
						if (res.data.success) {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Added in Card",
							});
							getProducts();
							getCart(productInfo.user_id);

							if (dataLayerCart === null) {
								Helper.setStorage("dataLayerCart", productInfo);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: productInfo,
									},
								});
							} else {
								let dataLayerCartCopy = [dataLayerCart];
								dataLayerCartCopy.push(productInfo);
								Helper.setStorage("dataLayerCart", dataLayerCartCopy);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: dataLayerCartCopy,
									},
								});
							}
						} else {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Already in Cart",
							});
							return;
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};
	const addItem = (item) => {
		const cart = Helper.getStorage("cart");
		if (cart) {
			let cartCopy = [...cart];
			let { id } = item;
			let existingItem = cartCopy.find((cartItem) => cartItem.id == id);

			if (existingItem) {
				setSnackBarProps({
					openSnack: true,
					variant: "success",
					message: "Product Already in Cart",
				});
				return;
			} else {
				cartCopy.push(item);
			}
			setCart(cartCopy);
			setCartState(cartCopy);
			Helper.setStorage("cart", cartCopy);
			setSnackBarProps({
				openSnack: true,
				variant: "success",
				message: "Product Added in Card",
			});
			window.dataLayer.push({
				event: "add_to_cart",
				ecommerce: {
					currency: "",
					value: "",
					items: cartCopy,
				},
			});
		} else {
			let cart = [];
			let cartCopy = [...cart];
			let { id } = item;
			let existingItem = cartCopy.find((cartItem) => cartItem.id == id);

			if (existingItem) {
				setSnackBarProps({
					openSnack: true,
					variant: "success",
					message: "Product Already in Cart",
				});
				return;
			} else {
				cartCopy.push(item);
			}
			setCart(cartCopy);
			setCartState(cartCopy);
			Helper.setStorage("cart", cartCopy);
			setSnackBarProps({
				openSnack: true,
				variant: "success",
				message: "Product Added in Card",
			});
			window.dataLayer.push({
				event: "add_to_cart",
				ecommerce: {
					currency: "",
					value: "",
					items: cartCopy,
				},
			});
		}
		getProducts();
	};
	const getCart = (id) => {
		let data = { user_id: id };
		ApiHelper.post(APIURLConstants.GET_CART, data)
			.then((res) => {
				// setCartCount(res.data.result.products.length);
				setCartState(res.data.result.products);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		getProducts();
	}, [perPage, currentPage]);
	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				flexDirection: { xs: "column", md: "row" },
				justifyContent: "center",
				alignContent: "center",
			}}
		>
			<Box
				width={"100%"}
				display={"flex"}
				flexDirection={{ xs: "column", md: "row" }}
			>
				<Box
					display={"flex"}
					flexDirection={"column"}
					gap={{ xs: 1, md: 4 }}
					p={{ xs: 2, md: 12 }}
				>
					<Typography
						width={{ xs: "100%", md: "80%" }}
						variant="h3"
						color="primary.main"
						fontSize={{ xs: 35, md: 48 }}
						letterSpacing={"0%"}
						sx={{ textShadow: "2px 2px #000000", mt: { xs: 2, md: 8 } }}
					>
						{"Start Your E-Commerce Journey with Confidence"}
					</Typography>
					<Box display={"flex"} flexDirection={"column"} width={"95%"}>
						<Typography
							color="primary.main"
							fontSize={{ xs: 15, md: 25 }}
							width={"100%"}
						>
							{
								"Ecom Insider is here to help you launch a successful e-commerce business by giving you data on high-performing, proven products."
							}
						</Typography>
						<Typography
							color="primary.main"
							fontSize={{ xs: 15, md: 25 }}
							width={"100%"}
						>
							{
								"Save time, slash guesswork, and skyrocket your profits with data-driven insights trusted by top sellers. "
							}
						</Typography>
						<Typography
							color="primary.main"
							fontSize={{ xs: 15, md: 25 }}
							width={"100%"}
						>
							{
								" Stop scrolling and start selling smarter—your next winning product is one click away. "
							}
						</Typography>

						{/* <Typography
							color="primary.main"
							fontSize={{ xs: 15, md: 20 }}
							width={"100%"}
						>
							{
								" Save time, slash guesswork, and skyrocket your profits with data-driven insights trusted by top sellers. "
							}
						</Typography> */}
						{/* <Typography
							color="primary.main"
							fontSize={{ xs: 15, md: 20 }}
							width={"100%"}
						>
							{
								"Stop scrolling, start selling smarter. Your next winning product is one click away."
							}
						</Typography> */}
					</Box>
					<Button
						color="inherit"
						sx={{
							alignItems: "center",
							justifyContent: "center",
							my: "auto",
							color: "secondary.main",
							bgcolor: "primary.main",
							px: { xs: 0, md: 2 },
							// mx: { xs: "-5px" },
							height: { xs: "23px", md: "70px" },
							// minWidth: "46px",
							borderRadius: 8,
							// width: { xs: "20px" },
							width: { md: "242px" },
						}}
						onClick={() => handlePayment(1)}
					>
						<Typography
							textTransform={"capitalize"}
							fontSize={{ xs: 10, md: 16 }}
							fontWeight={600}
							// sx={{ textShadow: "1px 1px #000000" }}
						>
							{"Subscribe Now for $1"}
						</Typography>
					</Button>
				</Box>

				<Box
					sx={{
						display: { xs: "none", md: "block" },
						height: { xs: "310px", md: "690px" },
						width: { xs: "310px", md: "100%" },
						background: `url(${Man})`,
						backgroundSize: "cover",
						mt: 4,
					}}
				>
					<Box
						sx={{
							marginTop: "56%",
							marginLeft: "-10%",
						}}
					>
						{products.map((product, index) => {
							return index === 0 ? (
								<ProductCard
									key={index}
									data={product}
									myAccount={false}
									addItem={addItem}
									addCartItem={addCartItem}
									// checkProductExist={checkProductExist}
								/>
							) : null;
						})}
					</Box>
				</Box>
				<Box
					sx={{
						display: { xs: "block", md: "none" },
						height: { xs: "280px", md: "690px" },
						width: { xs: "316px", md: "100%" },
						// borderRadius: 8,
						background: `url(${ManMobile})`,
						backgroundSize: "cover",
						mt: "-8px",
						ml: "-11px",
						float: "right",
					}}
				>
					<Box
						sx={{
							marginTop: "5%",
							marginLeft: "4%",
						}}
					>
						{products.map((product, index) => {
							return index === 0 ? (
								<MobileProductCard
									key={index}
									data={product}
									myAccount={false}
									addItem={addItem}
									addCartItem={addCartItem}
									// checkProductExist={checkProductExist}
								/>
							) : null;
						})}
					</Box>
				</Box>
				{/* <Box
					component={"img"}
					src={Man}
					height={"690px"}
					// width={"600px"}
					sx={{
						backgroundSize: "cover",
					}}
					alt="The Men."
				/> */}
			</Box>
		</Box>
	);
};
